import { RESET_STATE } from 'store/global/actions';
import { LOAN_ACTIONS_ACTION_TYPE } from 'store/loanApplications/actions';

const initialState = [];

const loanActionsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_ACTIONS_ACTION_TYPE.GET_LOAN_ACTIONS:
      return payload || state;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default loanActionsReducer;
